//基本路径
export let myBaseUrl='';
export let myAcivity='';//活动
export let myAcivityAddress='';//活动访问地址
export let myBaseUrlOa='';//oa
export let clooudBaseUrl='';//在线学习
//云平台
export let clooudBaseUrl_login = ""; //云登录页面
export let yjcsUrl = ""; //云接口(包括部分菜单地址)
export let yjcsUrl_new = ""; //新后台地址

if(process.env.NODE_ENV == 'production'){//生产环境
	if(process.env.VUE_APP_NAME=="build"){
    clooudBaseUrl = 'http://121.36.111.82/trainApi';//在线学习

    myBaseUrl = 'http://home.cqszedu.cn/cmsApi';
  }else if(process.env.VUE_APP_NAME=="build2"){//内部演示：build2
		//内部演示
    clooudBaseUrl = 'http://119.84.8.162:8694/trainApi';//在线学习
    myBaseUrl = 'http://119.84.8.162:8694/cmsApi'
  }else{//测试环境：alpha
    //测试
    clooudBaseUrl = 'http://119.3.243.157:8888/train';//在线学习
    myBaseUrl = 'http://119.3.243.157:8888/cms'
	}
}else{//开发环境，process.env.NODE_ENV == 'development'
  clooudBaseUrl = 'http://121.36.111.82/trainApi';//在线学习
  myBaseUrl = 'http://home.cqszedu.cn/cmsApi';
}
//上传文件的地址
export let fileUploadUrl = myBaseUrl+"/api/file/upload";
export let clooudFileUploadUrl = clooudBaseUrl+"/common/file/upload";

//接口
export const httpUrl={
  //=========================广告============================
  //广告位
  getSiteBill: myBaseUrl + '/api/banner/getSiteBill', //获取广告位列表
  addSite: myBaseUrl + '/api/banner/addSite', //添加修改广告位
  deleteSite: myBaseUrl + '/api/banner/deleteSite', //删除广告位
  //广告
  getBannerBill: myBaseUrl + '/api/banner/getBannerBill',//获取广告列表
  addBanner: myBaseUrl + '/api/banner/addBanner', //添加修改广告
  upperLower: myBaseUrl + '/api/banner/upperLower', //上架下架广告
  deleteBanner: myBaseUrl + '/api/banner/deleteBanner', //删除广告
  addClickRate: myBaseUrl + '/api/banner/addClickRate', //增加点击率
  //=========================广告============================

  //=========================在线培训============================

  trainingIndex : clooudBaseUrl + '/training/user/trainingIndex',//六枝在线学习首页

  cloudGetCourseClass: clooudBaseUrl + '/training/user/getCourseClass', //获取分类列表
  getSubjectList: clooudBaseUrl + '/training/course/getSubjectList', //获取分类列表
  // getTrainigInfoById: clooudBaseUrl + '/training/user/getTrainigInfoById', //获取培训详情
  getTrainigInfoById: clooudBaseUrl + '/training/publish/getTrainingById', //获取培训详情
  getTrainingList: clooudBaseUrl + '/training/user/getTrainingList', //获取培训列表
  joinCourse: clooudBaseUrl + '/training/user/addTraining', //加入课程
  exitCourse: clooudBaseUrl + '/training/user/exitTraining', //退出课程
  startStudy: clooudBaseUrl + '/training/user/startStudy', //开始学习
  updateStudyTime: clooudBaseUrl + '/training/user/updateStudyTime', //更新学习时间
  getMyTrainingList: clooudBaseUrl+ '/training/user/getMyTrainingList', //我的培训

  //考试-测验
  getExamList: clooudBaseUrl + '/training/userExam/getExamList', //获取历史测验/考试列表
  submitSectionTest: clooudBaseUrl + '/training/userExam/submitSectionTest', //用户提交章节测验答案
  startExam: clooudBaseUrl + '/training/userExam/startExam', //开始考试
  submitExamSubjectAnswer: clooudBaseUrl + '/training/userExam/submitExamSubjectAnswer', //提交单个考试题目答案
  submitExamPaper: clooudBaseUrl + '/training/userExam/submitExamPaper', //提交试卷
  getUserExamDetailInfo: clooudBaseUrl + '/training/userExam/getUserExamDetailInfo', //根据用户考试ID获取考试详情
  getExamPaperDetailInfoById: clooudBaseUrl + '/training/userExam/getExamPaperDetailInfoById', //根据考试/测验ID获取测验/考试 试卷详情
  submitRedoSubjectAnswer: clooudBaseUrl + '/training/userExam/submitRedoSubjectAnswer', //提交重做答案

  //获取机构黑白名单
  getOrgInfoList: myBaseUrl + '/api/trainOrg/getOrgInfoList',//获取培训机构列表

  //==============4.30课堂=============
  getCourseList: myBaseUrl + '/api/depositCourse/getCourseList',
  //==============4.30课堂=============
}
